export function getInitialLanguage() {
	try {
		// Check if lang is stored in localStorage
		const savedLang = localStorage.getItem("lang");
		if (savedLang) {
			return savedLang;
		}
	} catch (err) {
		console.warn("Failed to load initial language:", err);
	}

	return "es";
}
